var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { cx, css as emotionCss } from 'emotion';
import { getChildrenByType } from 'react-nanny';
import { citrusStyled, getAutomation, getDebug, getStyleNames } from '@citrus/runtime';
import { iif, isNotNullOrEmpty } from '@pcty/utils';
import { useTable } from './private/TableContext';
import { trDisabled as trDisabledLegacy } from '../styles/legacy';
import { trDisabled as trDisabledCitron } from '../styles/citron';
import { Thead as Component } from './Table.styled';
import { useTheme } from '@citrus/user';
var VERSION = '6.12.2';
var Thead = function (_a) {
    var _b, _c;
    var automationId = _a.automationId, children = _a.children, className = _a.className, css = _a.css, disabled = _a.disabled, _d = _a.__TYPE, TYPE = _d === void 0 ? 'Thead' : _d, other = __rest(_a, ["automationId", "children", "className", "css", "disabled", "__TYPE"]);
    var isCitron = useTheme().citrus2022;
    var trDisabled = iif(isCitron, trDisabledCitron, trDisabledLegacy);
    var _e = useTable(), dividerIndexes = _e.dividerIndexes, expandable = _e.expandable, renderGroups = _e.renderGroups;
    var cols = getChildrenByType(children, ['Th', 'ThCheckbox']);
    if (isNotNullOrEmpty(cols)) {
        cols = cols.map(function (x, index) {
            var _a, _b;
            return React.cloneElement(x, {
                disabled: disabled ? true : x.props.disabled,
                key: isNotNullOrEmpty(automationId) ? "data-table-thead-".concat(automationId, "-").concat(index) : "data-table-thead-".concat(index),
                divider: (_a = x.props.divider) !== null && _a !== void 0 ? _a : (dividerIndexes === null || dividerIndexes === void 0 ? void 0 : dividerIndexes.indexOf(index - (expandable ? 1 : 0))) >= 0,
                dividerBefore: (_b = x.props.dividerBefore) !== null && _b !== void 0 ? _b : (dividerIndexes === null || dividerIndexes === void 0 ? void 0 : dividerIndexes.indexOf(index - (expandable ? 2 : 1))) >= 0,
            });
        });
    }
    var classes = cx((_b = {},
        _b[emotionCss(css)] = isNotNullOrEmpty(css),
        _b), className || '');
    var emotionObj = (_c = {},
        _c[emotionCss(trDisabled)] = disabled,
        _c);
    var classesRow = cx(emotionObj, className || '');
    var styleNames = {
        trDisabled: emotionObj[emotionCss(trDisabled)],
    };
    var Tr = citrusStyled.tr('N/A', null);
    return (React.createElement(Component, __assign({ className: classes, styleNames: getStyleNames(styleNames) }, other, getAutomation(automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', TYPE, VERSION)), renderGroups === null || renderGroups === void 0 ? void 0 :
        renderGroups(),
        React.createElement(Tr, { className: classesRow }, cols)));
};
Thead.defaultProps = {
    __TYPE: 'Thead',
};
export default Thead;
